import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

interface UsePayoutsProps {
  currentPage: number;
  enabled?: boolean;
}

interface UsePayoutsResponse extends ResponseObject {
  page_number: number;
  page_size: number;
  count_total: number;
  has_more: true;
  payouts: Api.Influencer.Payout[];
}

export function usePayouts({ currentPage, enabled }: UsePayoutsProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: `influencer-payouts-${currentPage}`,
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/payouts/search?&page_size=${10}${currentPage ? `&page_number=${currentPage}` : ''}`,
        token
      }).then((response: UsePayoutsResponse) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return {
          pageNumber: response.page_number,
          pageSize: response.page_size,
          countTotal: response.count_total,
          hasMore: response.has_more,
          payouts: response.payouts
        };
      }),
    enabled: !!token && enabled
  });

  return {
    data,
    error,
    isLoading,
    refetch
  };
}
